module.exports = __webpack_public_path__ + "static/media/Neuro-musculo-skeletal_function.d124537e.png";